import React from "react";
import {
  UsersRound,
  GraduationCap,
  CircleDollarSign,
  BookOpen,
  HandHeart,
  Star,
  ArrowRight,
  ArrowUpRight,
  Users,
  Building2,
  Globe,
} from "lucide-react";
import { positions, stats, LINKEDIN_URL } from "../data/mock";

const iconMap = {
  UsersRound,
  GraduationCap,
  CircleDollarSign,
  BookOpen,
  HandHeart,
  Star,
  Users,
  Building2,
  Globe,
};

const OpenPositionsSection = () => {
  const goLinkedIn = () => window.open(LINKEDIN_URL, "_blank", "noopener,noreferrer");

  return (
    <section className="relative w-full bg-white py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Left intro + stats */}
          <div className="lg:col-span-4">
            <span className="text-[12px] font-semibold tracking-[0.18em] text-[#FF7A1A] uppercase">
              Explore Opportunities
            </span>
            <h2 className="font-display text-4xl lg:text-5xl font-extrabold text-slate-900 mt-3 leading-tight">
              Open Positions
            </h2>
            <p className="mt-4 text-slate-500 text-[15px] leading-relaxed max-w-md">
              Find the role that matches your passion and skills. Be a part of
              our mission to make global education accessible for everyone.
            </p>

            <button
              onClick={goLinkedIn}
              className="btn-outline-orange mt-7 inline-flex items-center gap-2 rounded-xl px-5 py-3 text-[14px] font-semibold"
            >
              View All Open Positions
              <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
            </button>

            {/* Stats card */}
            <div className="mt-8 rounded-2xl bg-[#E8F5EE] p-6 ring-1 ring-emerald-100">
              <div className="grid grid-cols-2 gap-6">
                {stats.map((s) => {
                  const Icon = iconMap[s.icon];
                  return (
                    <div key={s.id} className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center ring-1 ring-emerald-100">
                        <Icon className="w-5 h-5 text-emerald-600" strokeWidth={2.2} />
                      </div>
                      <div>
                        <div className="font-display text-2xl font-extrabold text-slate-900">
                          {s.value}
                        </div>
                        <div className="text-[12px] text-slate-500 mt-0.5">
                          {s.label}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Right - positions grid */}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {positions.map((p, idx) => {
                const Icon = iconMap[p.icon];
                return (
                  <div
                    key={p.id}
                    className={`card-hover bg-white rounded-2xl ring-1 ring-slate-100 p-6 fade-up delay-${Math.min(
                      idx + 1,
                      5
                    )}`}
                  >
                    <div
                      className={`w-11 h-11 rounded-xl ${p.iconBg} flex items-center justify-center mb-4`}
                    >
                      <Icon className={`w-5 h-5 ${p.iconColor}`} strokeWidth={2.2} />
                    </div>
                    <h3 className="font-display text-[17px] font-bold text-slate-900 leading-snug">
                      {p.title}
                    </h3>
                    <div className="mt-1 text-[12px] text-slate-500 flex items-center gap-2">
                      <span>{p.type}</span>
                      <span className="w-1 h-1 rounded-full bg-slate-300" />
                      <span>{p.mode}</span>
                    </div>
                    <p className="mt-4 text-[13.5px] leading-relaxed text-slate-500">
                      {p.description}
                    </p>
                    <button
                      onClick={goLinkedIn}
                      className="mt-5 inline-flex items-center gap-1.5 text-[#FF7A1A] text-[13.5px] font-semibold hover:gap-2.5 transition-all"
                    >
                      View Details
                      <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpenPositionsSection;
